import { render, staticRenderFns } from "./userDetailIntegralDetail.vue?vue&type=template&id=84dfa176&scoped=true"
import script from "./userDetailIntegralDetail.vue?vue&type=script&lang=js"
export * from "./userDetailIntegralDetail.vue?vue&type=script&lang=js"
import style0 from "./userDetailIntegralDetail.vue?vue&type=style&index=0&id=84dfa176&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84dfa176",
  null
  
)

export default component.exports